<template>
  <div class="field-validation">
    <span
      v-show="isValid && showIndicator"
      class="field-validation__indicator"
      v-data-test-id="'indicator'"
    ></span>
    <div v-if="isMessageVisible && message" :class="`field-validation__${type}`">{{ message }}</div>
  </div>
</template>

<script>
export const TYPES = {
  error: 'error',
  warning: 'warning',
}

export default {
  name: 'FieldValidation',

  props: {
    isValid: {
      type: Boolean,
      default: true,
    },
    isMessageVisible: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: TYPES.error,
      validator(value) {
        return Object.values(TYPES).includes(value)
      },
    },
    showIndicator: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/components/_shared/Form/form-settings';

.field-validation {
  &__error {
    @include field-validation-error;
  }

  &__warning {
    @include field-validation-warning;
  }

  &__indicator {
    @include field-validation-valid-indicator;
  }
}
</style>
